import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { UserService } from 'shared/core/services/user/user.service';

import { EmptyLayoutComponent } from './layouts/empty-layout/empty-layout.component';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { HeaderLayoutComponent } from './layouts/header-layout/header-layout.component';
import { pulseRoutes } from './products/config/pulseRoutes';

const PRODUCT_ROUTES = [...pulseRoutes];

const routes: Routes = [
    {
        path: '',
        component: EmptyLayoutComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                canActivate: [
                    async () => {
                        const userService = inject(UserService);
                        await userService
                            .checkAuthenticationAsPromise()
                            .catch(() => false);
                        return true;
                    },
                ],
                loadComponent: () =>
                    import('./pages/landing/pulse.component').then(m => m.PulseComponent),
            },
            {
                path: 'login',
                loadComponent: () =>
                    import('shared/pages/auth/auth.page').then(m => m.AuthPage),
            },
            {
                path: 'tenant-picker',
                loadComponent: () =>
                    import('shared/pages/tenant-picker/tenant-picker.page').then(
                        m => m.TenantPickerPage
                    ),
            },
            {
                path: 'logout',
                loadComponent: () =>
                    import('shared/pages/logout/logout.page').then(m => m.LogoutPage),
            },
        ],
    },
    {
        path: '',
        component: HeaderLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '404',
                loadComponent: () =>
                    import('./pages/not-found/not-found.page').then(m => m.NotFoundPage),
            },
            {
                path: 'pulse',
                loadComponent: () =>
                    import('./pages/landing/pulse.component').then(m => m.PulseComponent),
            },
            {
                path: 'achievements',
                loadComponent: () =>
                    import('app/main/dashboard-header-nav/achievements/achievements.view.component').then(
                        m => m.AchievementsViewComponent
                    ),
            },
            {
                path: 'admin',
                loadComponent: () => import('./pages/admin/admin').then(m => m.Admin),
            },
            {
                path: 'profile',
                loadComponent: () =>
                    import('./pages/profile/profile').then(m => m.Profile),
            },
            {
                path: 'alerts',
                loadComponent: () => import('./pages/alerts/alerts').then(m => m.Alerts),
            },
        ],
    },
    {
        path: '',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'products',
                children: [...PRODUCT_ROUTES, {
                    path: '**',
                    title: 'Pulse - Page not found',
                    loadComponent: () => import('./pages/not-found/not-found.page').then(m => m.NotFoundPage),
                }],
            },
        ],
    },
    {
        path: '**',
        component: HeaderLayoutComponent,
        canActivate: [AuthGuard],
        children: [{
            path: '', title: 'Pulse - Page not found',
            loadComponent: () => import('./pages/not-found/not-found.page').then(m => m.NotFoundPage),
        }],
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            enableTracing: false,
            initialNavigation: 'enabledNonBlocking',
            paramsInheritanceStrategy: 'always',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
